import React, { useEffect } from 'react';
import styles from '@/styles/ContactInformationComponent.module.scss';
import { getCTAS, getConditionalStatusWithPartnerStatus } from '@/utils';
import { PEIHeadLine, PEISectionFooter, PEIScalableTable, FlexibleTableProps } from '@/common';
import { useAppContext } from '@/components';

type FundsManagedComponentProps = {
  institutionID: string;
  institutionName: string;
  inMarketFunds: FlexibleTableProps;
  inMarketFundsCount: number;
  partnerStatus: string;
  closedFundsCount: number;
  userType: string;
  closedFunds: FlexibleTableProps;
};

export const FundsManagedComponent = ({
  institutionName,
  institutionID,
  inMarketFunds,
  inMarketFundsCount,
  closedFundsCount,
  closedFunds,
  partnerStatus,
  userType,
}: FundsManagedComponentProps) => {
  const { dispatch } = useAppContext();

  useEffect(() => {
    dispatch({
      type: 'setRecordInfo',
      payload: {
        key: 'funds-managed',
        value: inMarketFunds.length > 0 || closedFunds.length > 0,
      },
    });
  }, [dispatch, inMarketFunds, closedFunds]);

  const allData = getCTAS(userType, institutionName, institutionID);
  const fundsManagedComponentData: {
    ctaHeading: string;
    GP: string;
    'LP/GP': string;
  } = allData['FundsManagedComponent'];

  const ctas = {
    ctaButton: '',
  };

  switch (partnerStatus) {
    case 'GP':
      ctas.ctaButton = fundsManagedComponentData.GP;
      break;
    case 'LP/GP':
      ctas.ctaButton = fundsManagedComponentData['LP/GP'];
      break;
  }

  const fundsManaged = getConditionalStatusWithPartnerStatus('funds-managed', partnerStatus);
  return fundsManaged ? (
    <article className={styles.container} id='funds-managed'>
      <main className={styles['container-body']}>
        <PEIHeadLine text={`${institutionName} funds managed`} />
        {inMarketFunds.length > 0 && (
          <PEIScalableTable
            title='Funds in market'
            count={inMarketFundsCount}
            data={inMarketFunds}
            headers={['Fund', 'Fund size', 'Open date', 'Strategy']}
            start={inMarketFunds.length}
            end={inMarketFundsCount}
            institutionName={institutionName}
            componentName='funds in market'
          />
        )}

        {closedFunds.length > 0 && (
          <PEIScalableTable
            title='Closed funds'
            count={closedFundsCount}
            data={closedFunds}
            headers={['Fund', 'Fund size', 'Close date', 'Strategy']}
            start={closedFunds.length}
            end={closedFundsCount}
            institutionName={institutionName}
            componentName='closed funds'
          />
        )}
      </main>
      <PEISectionFooter textToShow={fundsManagedComponentData.ctaHeading} link={ctas.ctaButton} />
    </article>
  ) : (
    <></>
  );
};
